import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const CrudIntegracaoList = (props) => <DefaultDataTable data={props} />
